import { React, useState, useEffect } from "react";
import { ReactComponent as Homeicon } from "../../assets/icons/Home.svg";
import Yupup from "./../../assets/icons/newLogo.svg";
import { ReactComponent as Order } from "./../../assets/icons/order.svg";
import { ReactComponent as Profile } from "./../../assets/icons/profile.svg";
import { ReactComponent as Msg } from "./../../assets/icons/msg.svg";
import { ReactComponent as Add } from "./../../assets/icons/arrow.svg";
import { ReactComponent as Settings } from "./../../assets/icons/settings.svg";
import { ReactComponent as Support } from "./../../assets/icons/support.svg";
import { ReactComponent as Logout } from "./../../assets/icons/logout.svg";
import { colors } from "../../share/constants/enums";
import { Divider } from "antd";
import { Link } from "react-router-dom";
import { Menu } from "antd";
import { Layout } from "antd";
import { clearLocalStorage } from "../../share/utils";
import { logout } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../store/slices/userSlice";
import { EnvironmentFilled, ShopOutlined } from "@ant-design/icons";

const { Sider } = Layout;

const Sidenav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userFcmToken = useSelector((state) => state?.user);
  const [activeItem, setActiveItem] = useState("home");

  const handleItemClick = (itemKey) => {
    if (itemKey === "logout") {
      setActiveItem("logout");
    } else setActiveItem(window.location.pathname.split("/")[2]);
  };

  const handleProfileClick = () => {
    handleItemClick("profile");
  };

  const handleLogout = async () => {
    const payload = {};
    if (userFcmToken?.fcmToken) {
      payload.fcmToken = userFcmToken?.fcmToken;
    }

    const res = await logout(payload);
    if (res?.status) {
      clearLocalStorage();
      dispatch(reset());
    }
    navigate("/login");
  };

  useEffect(() => {
    setActiveItem(window.location.pathname.split("/")[2]);
  }, [window.location.pathname]);

  return (
    <Sider breakpoint="lg" collapsedWidth="0" className="position-fixed">
      <div className="demo-logo-vertical" />
      <Menu
        className="bg-primaryPurple h-screen text-white flex flex-col justify-between"
        mode="inline"
      >
        <Menu.Item
          key="logo"
          className="!h-20 p-2 pointer-events-none opacity-100"
        >
          <img src={Yupup} className="h-8" alt="Yupup Logo" />
        </Menu.Item>

        <div className=" px-2 h-full">
          <Menu.Item
            key="home"
            icon={<Homeicon />}
            className={`h-5.4  ${
              activeItem === "home" ? "active-menu-item" : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "home" ? colors.primaryBlue : "transparent",
              color: activeItem === "home" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("home")}
          >
            <Link to="/main/home">Home</Link>
          </Menu.Item>

          <Menu.Item
            key="orders"
            icon={<Order />}
            className={`h-5.4 p-1 ${
              activeItem === "orders" ? "active-menu-item" : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "orders" ? colors.primaryBlue : "transparent",
              color: activeItem === "orders" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("order")}
          >
            <Link to="/main/orders">Orders</Link>
          </Menu.Item>
          <Menu.Item
            key="ads"
            icon={<Add />}
            className={`h-5.4 ${
              activeItem === "ads" ? "active-menu-item" : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "ads" ? colors.primaryBlue : "transparent",
              color: activeItem === "ads" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("ads")}
          >
            <Link to="/main/ads">Ads</Link>
          </Menu.Item>
          <Menu.Item
            key="profile"
            icon={<Profile />}
            className={`h-5.4 ${
              activeItem === "profile"
                ? "active-menu-item"
                : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "profile" ? colors.primaryBlue : "transparent",
              color: activeItem === "profile" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={handleProfileClick}
          >
            <Link to="/main/profile">Profile</Link>
          </Menu.Item>
          <Menu.Item
            key="location"
            icon={<EnvironmentFilled className="!text-[22px]" />}
            className={`p-2${
              activeItem === "location"
                ? "active-menu-item"
                : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "location" ? colors.primaryBlue : "transparent",
              color: activeItem === "location" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("location")}
          >
            <Link to="/main/location">Locations</Link>
          </Menu.Item>
          <Menu.Item
            key="public-profile"
            icon={<ShopOutlined className="!text-[20px]" />}
            className={`h-5.4 ${
              activeItem === "public-profile"
                ? "active-menu-item"
                : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "public-profile"
                  ? colors.primaryBlue
                  : "transparent",
              color: activeItem === "public-profile" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("public-profile")}
          >
            <Link to="/main/public-profile">Public profile</Link>
          </Menu.Item>
        </div>

        <div className="px-2">
          <Divider className="#6B43E0 h-1px " plain />
          <Menu.Item
            key="settings"
            icon={<Settings />}
            className={`h-5.4 ${
              activeItem === "settings"
                ? "active-menu-item"
                : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "settings" ? colors.primaryBlue : "transparent",
              color: activeItem === "settings" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("settings")}
          >
            <Link to="/main/settings">Settings</Link>
          </Menu.Item>
          <Menu.Item
            key="support"
            icon={<Support />}
            className={`h-5.4 ${
              activeItem === "support"
                ? "active-menu-item"
                : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "support" ? colors.primaryBlue : "transparent",
              color: activeItem === "support" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => handleItemClick("support")}
          >
            <Link to="/main/support">Support</Link>
          </Menu.Item>
          <Menu.Item
            key="logout"
            icon={<Logout />}
            className={`h-5.4 ${
              activeItem === "logout" ? "active-menu-item" : "hover:!text-white"
            }`}
            style={{
              backgroundColor:
                activeItem === "logout" ? colors.primaryBlue : "transparent",
              color: activeItem === "logout" ? "white" : "inherit",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            onClick={() => {
              handleItemClick("logout");
              handleLogout();
            }}
          >
            Logout
          </Menu.Item>
        </div>
      </Menu>
    </Sider>
  );
};
export default Sidenav;
